import { Component, ViewChild } from "@angular/core";
import { PonderAuthClient } from "@apiserver-rest/ponder-auth-client";
import { GetCheckoutSessionResponse } from "@apiserver-rest/ponder-auth-client-base";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { SvgIconComponent } from "@ponder-shared/components/svg-icon.component";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { StripeError } from "@stripe/stripe-js";
import { injectStripe, StripeElementsDirective } from "ngx-stripe";
import { take } from "rxjs";

@Component({
    selector: "new-payment-method",
    imports: [SvgIconComponent, BusySpinComponent],
    templateUrl: "./new-payment-method.component.html"
})
export class NewPaymentMethodComponent {
    @ViewChild(StripeElementsDirective) elements!: StripeElementsDirective;

    public readonly addSvgIcon: SvgIcon = SvgIcon.New;

    public isProcessing: boolean = false;
    public error: boolean = false;
    public errorMessage?: string;

    private stripe = injectStripe();
    private readonly defaultError: string = "Error adding new payment method!";

    public constructor(private ponderAuthClient: PonderAuthClient, private events: EventBroker) {

    }

    public onAddPaymentMethodClicked(): void {
        if (this.isProcessing) {
            return;
        }

        this.isProcessing = true;
        this.error = false;
        this.errorMessage = undefined;
        
        this.ponderAuthClient
            .subscriptionCheckoutSession()
            .pipe(take(1))
            .subscribe({
                next: (response: GetCheckoutSessionResponse) => {
                    if (response.id) {
                        this.stripe.redirectToCheckout({ sessionId: response.id })
                            .pipe(take(1))
                            .subscribe({
                                next: (response: { error?: StripeError }) => {
                                    if (response.error) {
                                        this.displayErrorMessage(response.error.message);
                                    }
                                },
                                error: () => {
                                    this.displayErrorMessage();
                                }
                            })
                    } else {
                        this.displayErrorMessage(response.error);
                        this.isProcessing = false;
                    }
                },
                error: () => {
                    this.displayErrorMessage();
                    this.isProcessing = false;
                }
            });
    }

    private displayErrorMessage(message?: string): void {
        this.events.ui.displayErrorEvent.emit({ message: message ?? this.defaultError, durationSec: 5 });
    }
}